module.exports = __webpack_public_path__ + "img/cowboyface.6b9c9fc9.png";